import(/* webpackMode: "eager" */ "/app/apps/web/app/(public)/product/treasury/page.tsx");
